import { getConversationById } from '../../../helpers'
import { ChatState } from '../types'

export const onBackgroundConversationUpdateStart = (
  state: ChatState,
  threadId: string
): ChatState => {
  const conversation = getConversationById(state.conversations, threadId)
  if (!conversation) {
    return state
  }

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [conversation.id]: {
        ...conversation,
        updating: 'PENDING',
      },
    },
  }
}
